import React, { Suspense } from 'react';
import styled, { withTheme } from "styled-components"
import config from 'src/config/config';
import { withAppContext } from 'src/store/initAppContext';
import { theme } from 'styled-tools';
import Intl from 'src/components/common/Intl';

const BonusContainer = React.lazy(() => import('./BonusContainer'));

const bonusInfo = [
    {
        image: "FirstTimeDeposit",
        name: <Intl langKey="PROMOTIONSTITLE@WELCOME"/>,
        url: "welcome-bonus",
        id: 1,
        authkey: "showWelcomeBonus"
    },
    {
        image: "ReDeposit",
        name: <Intl langKey="PROMOTIONSTITLE@REFILL" />,
        url: "refill-bonus",
        id: 2,
        authkey: "showRefillBonus"
    },
    {
        image: "RebatBonus",
        name: <Intl langKey="PROMOTIONSTITLE@CASHBACK" />,
        url: "cashback-bonus",
        id: 3,
        authkey: "showCashbackBonus"
    }
]

const BonusHomepage = (props) => {
    const { theme } = props;
    const { config: { showPromotions = true } } = theme;
    return showPromotions ? (
        <>
            <Wrapper1>
                <h3><Intl langKey="TITLE@PROMOTIONSTAGLINE" /></h3>
            </Wrapper1>
            <BonusHomepageWrapper>
                <Suspense fallback={<div>Loading...</div>}>
                    {bonusInfo.map((bonus) => {
                        const authKey = bonus.authkey;
                        const themeCong = theme.config;
                        const toShow = themeCong.hasOwnProperty(authKey) ? themeCong[authKey] : true;

                        return toShow ? (<BonusContainer
                            key={bonus.url}
                            bonusImage={bonus.image}
                            bonusTitle={bonus.name}
                            bonusUUID={`/promotions/${bonus.url}`}
                            imageId={bonus.id}
                        />) : null
                    }
                    )}
                </Suspense>
            </BonusHomepageWrapper>
        </>
    ) : null
}

export default withTheme(withAppContext(BonusHomepage));

const BonusHomepageWrapper = styled.div`
   width: 100%;
   display: flex;
   justify-content: center;
   padding: ${theme('palette.BonusHomepageWrapperPaddingNew')};
   background-image: url(${config.imageV3Host}/static/cashsite/${theme('image.new_whitelable_bonusHomePage_bg')});
   background-size: cover;
   background-repeat: no-repeat;
   gap: 1rem;
`;

export const Wrapper1 = styled.div`
    width: 100%;
    /* height: 79px; */
    height: ${theme('palette.bonusHomePageTittleHeight')};
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    padding-bottom: 5px;
    padding-top: ${theme('palette.bonusHomePageTittlePaddingTop')};
    /* background-image: url(${config.imageV3Host}/static/cashsite/${theme('image.new_whitelable_separator_v2_homepage')}); */
    background-image: url(${config.imageV3Host}/static/cashsite/${theme('image.bonusHomePgeTitleBg')});
    background-size: cover;
    background-repeat: no-repeat;
   

    h3 {
        display: flex;
        color: ${theme('palette.homeTittleTexts')};
        text-transform: uppercase;
        font-size: 30px;
        letter-spacing: 0.05em;
        margin: 0;
        line-height: 35px;
        padding-left: 40px;

        @media only screen and (min-width: 1800px){
            font-size: 35px;
        }
    }
    h2{
        display: flex;
        flex-direction: column;
        color: ${theme('palette.homeTittleTexts')};
        text-transform: uppercase;
        font-size: 25px;
        letter-spacing: 0.05em;
        margin: 0;
        line-height: 35px;
        padding-left: 40px;

        @media only screen and (min-width: 1800px){
            font-size: 35px;
        }
    }
`;